<template>
    <form action="">
        <app-form-select-input
            label="Perfil"
            v-model="form.profile"
            :options="profileOptions"
            :has-error="$v.form.profile.$error"
            error-message="Seleccione un perfil"
            :required="true"
            :is-object="true"
        />
        <app-form-text-input
            label="Documento"
            v-model="form.document"
            :has-error="$v.form.document.$error"
            error-message="Requerido (mín. 6 caracteres)"
            :required="true"
            :disabled="false"
            @input="onDocumentInput"
        />
        <p v-if="isContractorProfile && contractorFound" class="small text-success mt-1 mb-0">Contratista encontrado. Al guardar se vinculará al cliente.</p>
        <p v-else-if="isContractorProfile && documentSearchDone && !contractorFound && form.document.length >= 6" class="small text-warning mt-1 mb-0">No se encontró contratista con este documento. Complete los datos para crear uno nuevo.</p>
        <app-form-text-input
            label="Nombre"
            v-model="form.name"
            :has-error="$v.form.name.$error"
            error-message="Requerido"
            :required="!isContractorProfile || !contractorFound"
            :disabled="isContractorProfile && contractorFound"
        />
        <app-form-text-input
            label="Email"
            v-model="form.email"
            type="email"
            :has-error="$v.form.email.$error"
            error-message="Email válido requerido"
            :required="!isContractorProfile || !contractorFound"
            :disabled="isContractorProfile && contractorFound"
        />
        <app-form-text-input
            v-if="!isEdit"
            label="Username"
            v-model="form.username"
            :has-error="$v.form.username.$error"
            error-message="Requerido"
            :required="!isContractorProfile || !contractorFound"
            :disabled="isContractorProfile && contractorFound"
            placeholder="Se genera automáticamente (nombre + 4 dígitos)"
        />
        <app-form-text-input
            v-else
            label="Username"
            :value="form.username"
            disabled
        />
        <p v-if="!isEdit" class="small text-muted mt-1 mb-0">La contraseña será el número de documento.</p>
        <hr v-if="isContractorProfile">
        <div v-if="isContractorProfile" class="mt-2">
            <h6 class="mt-2">Información del contratista</h6>
            <p v-if="contractorFound && !isEdit" class="small text-muted mb-0">
                Complete sanción y fechas de autorización para este cliente.
            </p>
            <div class="row">
                <div class="col-md-6">
                    <app-form-text-input
                        label="Fecha expedición documento"
                        v-model="form.contractor.issue_date"
                        type="date"
                    />
                </div>
                <div class="col-md-6">
                    <label class="d-block mb-2">
                        Sancionado
                        <span v-if="needContractorAuthValidation" class="text-danger">*</span>
                    </label>
                    <div class="d-flex align-items-center">
                        <b-form-checkbox
                            switch
                            size="lg"
                            v-model="form.contractor.sanctioned"
                            :value="1"
                            :unchecked-value="0"
                            :state="needContractorAuthValidation && $v.form.contractor.sanctioned.$error ? false : null"
                            :aria-label="form.contractor.sanctioned === 1 ? 'Sancionado: sí' : 'Sancionado: no'"
                        />
                        <span class="ml-2 text-muted">{{ form.contractor.sanctioned === 1 ? 'Sí' : 'No' }}</span>
                    </div>
                    <p
                        v-if="needContractorAuthValidation && $v.form.contractor.sanctioned.$error"
                        class="small text-danger mb-0"
                    >
                        Indique si está sancionado (Sí o No)
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <app-form-text-input
                        label="Inicio autorización"
                        v-model="form.contractor.authorization_start_date"
                        type="date"
                        :has-error="needContractorAuthValidation && $v.form.contractor.authorization_start_date.$error"
                        error-message="Requerido"
                        :required="needContractorAuthValidation"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-text-input
                        label="Fin autorización"
                        v-model="form.contractor.authorization_end_date"
                        type="date"
                        :has-error="needContractorAuthValidation && $v.form.contractor.authorization_end_date.$error"
                        error-message="Requerido"
                        :required="needContractorAuthValidation"
                    />
                </div>
            </div>
            <h6 class="mt-3">Empresa contratista</h6>
            <app-form-text-input
                label="Nombre empresa"
                v-model="form.contractor.company_name"
            />
            <app-form-text-input
                label="NIT"
                v-model="form.contractor.company_nit"
            />
            <app-form-text-input
                label="Teléfono"
                v-model="form.contractor.company_phone"
            />
            <div v-if="isContractorProfile && clientHasContractorModule" class="mt-3">
                <h6 class="mt-2">Documentación obligatoria</h6>
                <p class="small text-muted mb-2">
                    Si no selecciona ningún tipo, se exigirán <strong>todos</strong> los tipos activos configurados para el cliente.
                    Elija uno o más si este contratista debe cumplir solo una parte de la lista.
                </p>
                <div v-if="contractorDocTypeOptions.length === 0" class="small text-muted">
                    No hay tipos activos configurados. Defínalos en «Tipos de documento contratista» del menú.
                </div>
                <template v-else>
                    <label id="client-user-contractor-doc-types-label" class="d-block mb-2">
                        Tipos de documento requeridos
                    </label>
                    <b-form-checkbox-group
                        id="client-user-contractor-doc-types"
                        v-model="form.contractor.required_document_type_ids"
                        :options="contractorDocTypeOptions"
                        stacked
                        name="contractor-required-document-types"
                        class="border rounded p-2 mb-2 bg-light contractor-doc-types-checkboxes"
                    />
                </template>
            </div>
        </div>
    </form>
</template>
<script>
import FormTextInput from '../../../UI/Controls/Forms/FormTextInput.vue';
import FormSelectInput from '../../../UI/Controls/Forms/FormSelectInput.vue';
import userRepository from '../../../../repositories/users.repository.js';
import contractorDocumentTypesRepository from '../../../../repositories/contractor-document-types.repository.js';
import { required, email, minLength } from 'vuelidate/lib/validators';

const ALLOWED_PROFILE_SLUGS = ['client-mobile-app', 'cliente-admin', 'contractor', 'sst'];

export default {
    components: {
        appFormTextInput: FormTextInput,
        appFormSelectInput: FormSelectInput
    },
    props: {
        selectedUser: { type: Object, default: null },
        clientContext: { type: Object, default: null },
        onSave: { type: Function, default: () => {} }
    },
    data() {
        return {
            form: {
                id: '',
                name: '',
                document: '',
                email: '',
                username: '',
                profile: null,
                contractor: {
                    issue_date: '',
                    sanctioned: 0,
                    authorization_start_date: '',
                    authorization_end_date: '',
                    company_name: '',
                    company_nit: '',
                    company_phone: '',
                    required_document_type_ids: []
                }
            },
            contractorFound: false,
            documentSearchDone: false,
            documentSearchTimeout: null,
            contractorDocTypeOptions: []
        };
    },
    computed: {
        isEdit() {
            return !!this.selectedUser && !!this.selectedUser.id;
        },
        isContractorProfile() {
            const p = this.form.profile;
            if (!p) return false;
            const slug =
                typeof p === 'object'
                    ? p.slug || (this.profileOptions.find(x => x.id === p.id) || {}).slug
                    : (this.profileOptions.find(x => x.id === p) || {}).slug;
            return slug === 'contractor';
        },
        profileOptions() {
            const profiles = this.$store.getters.profiles || [];
            return profiles.filter(p => ALLOWED_PROFILE_SLUGS.includes(p.slug));
        },
        clientForUsername() {
            return this.clientContext || this.$store.getters.client || {};
        },
        /** Fechas de autorización obligatorias al editar o al vincular contratista existente */
        needContractorAuthValidation() {
            return this.isContractorProfile && (this.isEdit || this.contractorFound);
        },
        /** Módulo contratista en el cliente seleccionado (desde página de usuarios cliente). */
        clientHasContractorModule() {
            const c =
                this.clientContext ||
                (this.$store && this.$store.getters && this.$store.getters.client) ||
                null;
            if (!c) {
                return false;
            }
            const mods = c.optional_modules || c.optionalModules;
            return (
                Array.isArray(mods) &&
                mods.some(m => m && (m.slug === 'contractor' || String(m.slug || '').toLowerCase() === 'contractor'))
            );
        }
    },
    watch: {
        selectedUser: {
            immediate: true,
            handler(val) {
                if (val) {
                    let profileObj = val.profile
                        ? {
                              id: val.profile.id,
                              slug: val.profile.slug,
                              name: val.profile.name
                          }
                        : null;
                    this.form = {
                        id: val.id,
                        name: val.name || '',
                        document: val.document || '',
                        email: val.email || '',
                        username: val.username || '',
                        profile: profileObj,
                        contractor: {
                            issue_date: '',
                            sanctioned: 0,
                            authorization_start_date: '',
                            authorization_end_date: '',
                            company_name: '',
                            company_nit: '',
                            company_phone: '',
                            required_document_type_ids: []
                        }
                    };
                    this.contractorFound = false;
                    this.documentSearchDone = false;
                    this.$nextTick(() => {
                        this.applyProfileSlugFromStore();
                        if (val.id && this.isContractorProfile) {
                            this.loadContractorForEdit(val.id);
                        }
                        if (this.isContractorProfile && this.clientHasContractorModule) {
                            this.loadContractorDocTypesOptions();
                        }
                    });
                } else {
                    this.resetForm();
                    this.$nextTick(() => {
                        if (!this.isEdit) this.form.username = this.generateUsername();
                    });
                }
            }
        },
        'form.profile'() {
            this.$nextTick(() => {
                this.applyProfileSlugFromStore();
                if (this.isEdit) {
                    return;
                }
                if (!this.isContractorProfile) {
                    this.contractorFound = false;
                    this.documentSearchDone = false;
                    return;
                }
                if (this.clientHasContractorModule) {
                    this.loadContractorDocTypesOptions();
                }
                const doc = (this.form.document || '').trim();
                if (doc.length >= 6) {
                    this.scheduleContractorSearch();
                } else {
                    this.contractorFound = false;
                    this.documentSearchDone = false;
                }
            });
        },
        isContractorProfile(v) {
            if (v && this.clientHasContractorModule) {
                this.loadContractorDocTypesOptions();
            }
        },
        clientContext() {
            if (this.isContractorProfile && this.clientHasContractorModule) {
                this.loadContractorDocTypesOptions();
            }
        },
        'form.name'() {
            if (!this.isEdit && !this.contractorFound) {
                this.form.username = this.generateUsername();
            }
        }
    },
    validations: {
        form: {
            name: {
                required: required(function() {
                    return !this.isContractorProfile || !this.contractorFound;
                })
            },
            document: { required, minLength: minLength(6) },
            email: {
                required: required(function() {
                    return !this.isContractorProfile || !this.contractorFound;
                }),
                email
            },
            username: {
                required: required(function() {
                    return !this.isEdit && (!this.isContractorProfile || !this.contractorFound);
                })
            },
            profile: { required },
            contractor: {
                authorization_start_date: {
                    required: required(function() {
                        return this.isContractorProfile && (this.isEdit || this.contractorFound);
                    })
                },
                authorization_end_date: {
                    required: required(function() {
                        return this.isContractorProfile && (this.isEdit || this.contractorFound);
                    })
                },
                sanctioned: {
                    /** `required` de Vuelidate falla con 0; el toggle solo usa 0 u 1 */
                    sanctionedChoice(value) {
                        if (!this.isContractorProfile || (!this.isEdit && !this.contractorFound)) {
                            return true;
                        }
                        return value === 0 || value === 1;
                    }
                }
            }
        }
    },
    methods: {
        loadContractorDocTypesOptions() {
            if (!this.clientHasContractorModule || !this.isContractorProfile) {
                this.contractorDocTypeOptions = [];
                return;
            }
            contractorDocumentTypesRepository
                .get({ status: 'active', per_page: 999 })
                .then(res => {
                    const pagination = res.data || {};
                    const rows = pagination.data || [];
                    this.contractorDocTypeOptions = rows.map(t => ({
                        value: Number(t.id),
                        text: t.code ? `${t.name} (${t.code})` : t.name
                    }));
                })
                .catch(() => {
                    this.contractorDocTypeOptions = [];
                    toastr.error('No se pudieron cargar los tipos de documento del cliente');
                });
        },
        contractorRequiredDocTypePayload() {
            const raw = this.form.contractor.required_document_type_ids || [];
            if (!Array.isArray(raw)) {
                return [];
            }
            const out = [];
            raw.forEach(id => {
                const n = parseInt(id, 10);
                if (!Number.isNaN(n) && n > 0 && out.indexOf(n) === -1) {
                    out.push(n);
                }
            });
            return out;
        },
        toDateInputValue(val) {
            if (val == null || val === '') return '';
            return String(val).split('T')[0];
        },
        applyProfileSlugFromStore() {
            const p = this.form.profile;
            if (!p || typeof p !== 'object' || !p.id) return;
            if (p.slug) return;
            const opt = this.profileOptions.find(x => x.id === p.id);
            if (opt) {
                this.form.profile = { ...p, slug: opt.slug, name: opt.name || p.name };
            }
        },
        async loadContractorForEdit(userId) {
            try {
                const res = await userRepository.getClientUserForEdit(userId);
                const payload = res.data;
                const u = payload.user;
                const cc = payload.contractor_client;
                if (!u) return;
                const ct = u.contractor;
                this.form.contractor.issue_date = this.toDateInputValue(ct && ct.issue_date);
                this.form.contractor.company_name = (cc && cc.name) || '';
                this.form.contractor.company_nit = (cc && cc.nit) || '';
                this.form.contractor.company_phone = (cc && cc.phone) || '';
                if (cc) {
                    this.form.contractor.sanctioned =
                        cc.sanctioned === null || cc.sanctioned === '' ? 0 : Number(cc.sanctioned);
                    this.form.contractor.authorization_start_date = this.toDateInputValue(
                        cc.authorization_start_date
                    );
                    this.form.contractor.authorization_end_date = this.toDateInputValue(
                        cc.authorization_end_date
                    );
                    const ids =
                        cc.required_document_type_ids != null && Array.isArray(cc.required_document_type_ids)
                            ? cc.required_document_type_ids
                            : [];
                    this.form.contractor.required_document_type_ids = ids.map(id => Number(id));
                }
            } catch (e) {
                /* ignore */
            }
        },
        slugify(text) {
            if (!text || typeof text !== 'string') return '';
            const from = 'áàäéèëíìïóòöúùüñçÁÀÄÉÈËÍÌÏÓÒÖÚÙÜÑÇ';
            const to = 'aaaeeeiiiooouuuncAAAEEEIIIOOOUUUNC';
            let s = text.trim().toLowerCase();
            for (let i = 0; i < from.length; i++) {
                s = s.replace(new RegExp(from[i], 'g'), to[i].toLowerCase());
            }
            return s.replace(/[^a-z0-9]+/g, '');
        },
        generateUsername() {
            const name = (this.form.name || '').trim();
            if (!name) return '';
            const firstPart = name.split(/\s+/)[0];
            const firstSlug = this.slugify(firstPart);
            if (!firstSlug) return '';
            const random4 = Math.floor(1000 + Math.random() * 9000);
            return firstSlug + random4;
        },
        resetForm() {
            this.form = {
                id: '',
                name: '',
                document: '',
                email: '',
                username: '',
                profile: null,
                contractor: {
                    issue_date: '',
                    sanctioned: 0,
                    authorization_start_date: '',
                    authorization_end_date: '',
                    company_name: '',
                    company_nit: '',
                    company_phone: '',
                    required_document_type_ids: []
                }
            };
            this.contractorFound = false;
            this.documentSearchDone = false;
            this.$nextTick(() => this.$v && this.$v.$reset());
        },
        /**
         * Debounce compartido: documento escrito o perfil cambiado a Contratista con documento ya válido.
         */
        scheduleContractorSearch() {
            if (this.documentSearchTimeout) {
                clearTimeout(this.documentSearchTimeout);
            }
            this.contractorFound = false;
            this.documentSearchDone = false;
            if (!this.isContractorProfile || this.isEdit) {
                return;
            }
            const doc = (this.form.document || '').trim();
            if (doc.length < 6) {
                return;
            }
            this.documentSearchTimeout = setTimeout(() => {
                this.executeContractorSearch();
            }, 400);
        },
        onDocumentInput() {
            this.scheduleContractorSearch();
        },
        executeContractorSearch() {
            if (!this.isContractorProfile || this.isEdit) {
                return;
            }
            const doc = (this.form.document || '').trim();
            if (doc.length < 6) {
                return;
            }
            userRepository
                .searchContractorByDocument(doc)
                .then(res => {
                    this.documentSearchDone = true;
                    if (res.data && res.data.status && res.data.user) {
                        this.applyFoundContractorFromSearch(res.data.user);
                    }
                })
                .catch(() => {
                    this.documentSearchDone = true;
                });
        },
        applyFoundContractorFromSearch(u) {
            const ct = u.contractor;
            const co = ct && ct.contractor_company;
            this.contractorFound = true;
            this.form.name = u.name || '';
            this.form.email = u.email || '';
            this.form.username = u.username || '';
            this.form.contractor.issue_date = this.toDateInputValue(ct && ct.issue_date);
            this.form.contractor.company_name = (co && co.name) || '';
            this.form.contractor.company_nit = (co && co.nit) || '';
            this.form.contractor.company_phone = (co && co.phone) || '';
            this.form.contractor.sanctioned = 0;
            this.form.contractor.authorization_start_date = '';
            this.form.contractor.authorization_end_date = '';
            this.form.contractor.required_document_type_ids = [];
        },
        save() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                toastr.error('Complete los campos obligatorios');
                return;
            }
            const profile = this.form.profile && (typeof this.form.profile === 'object' ? this.form.profile : { id: this.form.profile });
            if (!profile.id) {
                toastr.error('Seleccione un perfil');
                return;
            }

            const slug = profile.slug || (this.profileOptions.find(p => p.id === profile.id) || {}).slug;
            const linkContractorOnly = !this.isEdit && !this.form.id && slug === 'contractor' && this.contractorFound;

            if (linkContractorOnly) {
                const c = this.form.contractor || {};
                const payload = {
                    document: this.form.document,
                    profile: { id: profile.id, slug },
                    linkContractorOnly: true,
                    contractor: {
                        sanctioned: c.sanctioned === null || c.sanctioned === '' ? null : Number(c.sanctioned),
                        authorization_start_date: c.authorization_start_date || null,
                        authorization_end_date: c.authorization_end_date || null,
                        required_document_type_ids: this.contractorRequiredDocTypePayload()
                    }
                };
                const ur = Object.assign({}, userRepository);
                ur.saveClientUser(payload)
                    .then(data => {
                        if (data.status) {
                            toastr.success(data.msg || 'Contratista vinculado correctamente');
                            this.resetForm();
                            this.onSave(data.user || data);
                        } else {
                            toastr.error(data.msg || 'Error al vincular');
                        }
                    })
                    .catch(err => {
                        const msg = (err.response && err.response.data && err.response.data.msg) || 'Error al vincular el contratista';
                        toastr.error(msg);
                    });
                return;
            }

            const payload = {
                name: this.form.name,
                document: this.form.document,
                email: this.form.email,
                profile: { id: profile.id, slug }
            };
            if (!this.isEdit) {
                payload.username = this.form.username;
            }

            if (slug === 'contractor' && (!this.contractorFound || this.isEdit)) {
                const c = this.form.contractor || {};
                payload.contractor = {
                    issue_date: c.issue_date || null,
                    sanctioned: c.sanctioned === '' ? null : c.sanctioned,
                    authorization_start_date: c.authorization_start_date || null,
                    authorization_end_date: c.authorization_end_date || null,
                    required_document_type_ids: this.contractorRequiredDocTypePayload(),
                    company: {
                        name: c.company_name || null,
                        nit: c.company_nit || null,
                        phone: c.company_phone || null
                    }
                };
            }

            const ur = Object.assign({}, userRepository);
            const req = this.isEdit
                ? ur.updateClientUser(this.form.id, payload)
                : ur.saveClientUser(payload);

            req
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg || 'Guardado correctamente');
                        this.resetForm();
                        this.onSave(data.user || data);
                    } else {
                        toastr.error(data.msg || 'Error al guardar');
                    }
                })
                .catch(err => {
                    const msg = (err.response && err.response.data && err.response.data.msg) || 'Error al guardar el usuario';
                    toastr.error(msg);
                });
        }
    }
};
</script>
